import React from 'react';

const LineBreak = () => {
    return (
        <div className='flex flex-col items-center'>
            <div className='w-3/5'>
                <hr className='border-primary-dark-s1l1 dark:border-primary-light-s1l1 my-8' />
            </div>
        </div>
    )
}

export default LineBreak